import { render, staticRenderFns } from "./ding.vue?vue&type=template&id=3dca8123&scoped=true"
import script from "./ding.vue?vue&type=script&lang=js"
export * from "./ding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca8123",
  null
  
)

export default component.exports